import locationConstants from '../constants';
import authConstants from 'areas/auth/constants';

const initialState = { valid: false };

export function location(state = initialState, action) {
    switch (action.type) {
        case authConstants.SIGN_OUT_SUCCESS:
        case locationConstants.CLEAR:
        case authConstants.CONTINUE_SUCCESS:
            return initialState;

        case locationConstants.DIVISION_CHANGED:
            return {
                division: {
                    divisionID: action.divisionID,
                    divisionName: action.divisionName
                },
                project: null,
                site: null,
                zone: null,
                valid: false
            };

        case locationConstants.LOCATION_CHANGED:
            return {
                division: {
                    divisionID: action.divisionID,
                    divisionName: action.divisionName
                },
                project: {
                    projectID: action.projectID,
                    projectName: action.projectName
                },
                site: {
                    siteID: action.siteID,
                    siteCode: action.siteCode,
                    siteName: action.siteName
                },
                zone: action.zoneCode && action.zoneCode.length > 0 ? {
                    zoneID: action.zoneID,
                    zoneCode: action.zoneCode,
                    zoneName: action.zoneName
                } : null,
                valid: true
            };
        default:
            return state;
    }
}